import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {isMobile} from '../../helpers';

interface PathProps {
	parents?: {label: string; link: string}[];
	child?: string;
}

const PathComponent = ({parents, child}: PathProps) => {
	let cumulativePath = '';
	const location = useLocation();

	return (
		<div className='bg-white p-4 mb-6 flex items-center gap-3'>
			{parents &&
				parents.map((parent, index) => {
					cumulativePath += `/${parent.link}`;
					return (
						<React.Fragment key={cumulativePath}>
							<Link to={cumulativePath}>
								<p className='text-[13px] sm:text-lg'>{parent.label}</p>
							</Link>
							{index < parents.length - 1 && <span className='font-bold'> &gt; </span>}
						</React.Fragment>
					);
				})}

			{parents != null && parents?.length > 0 && location.pathname !== '/help' && (
				<span className='font-bold' style={{marginTop: isMobile() ? '-6px' : '0'}}>
					&gt;
				</span>
			)}

			<p className='text-[13px] sm:text-lg underline'>{child}</p>
		</div>
	);
};

export default PathComponent;
